// UserDetails/StatusActions/ShopStatusActions.jsx

import React, { useState } from "react";

export default function ShopStatusActions({ status, onChange }) {
  const [isUpdating, setIsUpdating] = useState(false);
  const [updateError, setUpdateError] = useState(null);

  const map =
    {
      PENDING: [
        ["Approve", "APPROVED", "bg-green-600 text-white"],
        ["Reject", "REJECTED", "bg-red-600 text-white"],
        ["Hold", "HOLD", "bg-yellow-400 text-black"],
      ],
      HOLD: [
        ["Approve", "APPROVED", "bg-green-600 text-white"],
        ["Reject", "REJECTED", "bg-red-600 text-white"],
      ],
      REJECTED: [
        ["Approve", "APPROVED", "bg-green-600 text-white"],
        ["Hold", "HOLD", "bg-yellow-400 text-black"],
      ],
      APPROVED: [
        ["Hold", "HOLD", "bg-yellow-400 text-black"],
        ["Reject", "REJECTED", "bg-red-600 text-white"],
      ],
    }[status] || [];

  const handleStatusChange = async (newStatus) => {
    try {
      setIsUpdating(true);
      setUpdateError(null);
      await onChange(newStatus);
    } catch (error) {
      setUpdateError(error.message || 'Failed to update shop status');
    } finally {
      setIsUpdating(false);
    }
  };

  return (
    <div className="mt-6 pt-4 border-t">
      {/* Error Message */}
      {updateError && (
        <div className="mb-4 p-3 bg-red-50 border border-red-200 rounded-md">
          <div className="text-red-600 text-sm">{updateError}</div>
          <button
            onClick={() => setUpdateError(null)}
            className="text-red-500 hover:text-red-700 text-xs mt-1"
          >
            ✕ Dismiss
          </button>
        </div>
      )}

      <div className="flex gap-3">
        {map.map(([label, val, color]) => (
          <button
            key={label}
            className={`flex-1 px-4 py-2 rounded-md font-bold hover:opacity-90 transition text-sm ${color} ${
              isUpdating ? 'opacity-50 cursor-not-allowed' : ''
            }`}
            onClick={() => handleStatusChange(val)}
            disabled={isUpdating}
          >
            {isUpdating ? (
              <div className="flex items-center justify-center space-x-2">
                <div className="animate-spin rounded-full h-4 w-4 border-t-2 border-b-2 border-current"></div>
                <span>Updating...</span>
              </div>
            ) : (
              label
            )}
          </button>
        ))}
      </div>
    </div>
  );
}
